import React from 'react';
import { Link } from 'react-router-dom';
import './Research.css';

const Research = () => {
  const researchCards = [
    {
      title: 'Computational Thinking',
      description: 'Computational thinking is a fundamental skill for everyone, not just computer scientists. Nozomi encourages decomposition, pattern recognition, abstraction, and algorithm design.',
      link: '/research/computational-thinking'
    },
    {
      title: 'Constructionism',
      description: 'Building on Seymour Paperts theory that learning happens most effectively when people create tangible objects in the real world. Our robot kit provides a physical embodiment of programming concepts.',
      link: '/research/constructionism'
    },
    {
      title: 'Learning Transfer',
      description: 'Designed to help users transfer problem-solving skills from programming to other domains, following research on near and far transfer of learning and cognitive flexibility.',
      link: '/research/learning-transfer'
    }
  ];

  return (
    <section id="research" className="section research-section">
      <div className="container">
        <div className="section-title">
          <h2>Research-Based Approach</h2>
          <p>Grounded in learning sciences and computational thinking research</p>
        </div>

        <div className="research-cards">
          {researchCards.map((card, index) => (
            <div className="research-card" key={index}>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <Link to={card.link} className="learn-more">Learn more</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Research;